import dishwasherIcon from "@/assets/icon-dishwasher.png";
import washingMachineIcon from "@/assets/icon-washing-machine.png";
import dryerIcon from "@/assets/icon-dryer.png";
import refrigeratorIcon from "@/assets/icon-refrigerator.png";
import ovenIcon from "@/assets/icon-oven.png";

/**
 * Returns a fallback line-art icon URL for an appliance category when no
 * real product image is available. Accepts either the category slug
 * (e.g. "dishwasher") or display label (e.g. "Dishwasher").
 */
export function getCategoryFallbackImage(category?: string | null): string | null {
  if (!category) return null;
  const key = category.toLowerCase().trim();
  // Washer Dryer has no dedicated icon asset yet — temporarily reuse the dryer icon.
  // TODO: replace with a dedicated washer-dryer icon once designed.
  if (key === "washer-dryer" || key === "washer dryer" || key.includes("washerdryer"))
    return dryerIcon;
  if (key === "dishwasher" || key.includes("dishwash")) return dishwasherIcon;
  if (key === "dryer" || key.includes("dryer") || key.includes("tumble")) return dryerIcon;
  if (key === "oven" || key.includes("oven")) return ovenIcon;
  if (
    key === "refrigerator" ||
    key.includes("refriger") ||
    key.includes("fridge")
  )
    return refrigeratorIcon;
  if (
    key === "washing-machine" ||
    key === "washing machine" ||
    key.includes("washing") ||
    key.includes("washer")
  )
    return washingMachineIcon;
  return null;
}
